import React, { useEffect } from 'react';
import { CheckboxChangeEventDetail, IonCheckbox } from '@ionic/react';
import clsx from 'clsx';
import './Checkbox.css';

export interface CheckboxProps {
  onChange: (value: boolean) => void;
  value: boolean;
  label?: React.ReactNode;
  color?:
    | 'danger'
    | 'dark'
    | 'light'
    | 'medium'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'tertiary'
    | 'warning';
  checkboxId?: string;
  disabled?: boolean;
  disableLabelClick?: boolean;
}

const Checkbox = ({
  onChange,
  value,
  label,
  color = 'primary',
  checkboxId,
  disabled,
  disableLabelClick,
}: CheckboxProps) => {
  let timeout;

  useEffect(() => {
    return () => {
      clearTimeout(timeout);
    };
  }, [timeout]);

  const handleCheckboxChange = ({
    detail,
  }: CustomEvent<CheckboxChangeEventDetail>) => {
    // Had to add 1ms timeout to prevent unstable_flushDiscreteUpdates error
    timeout = setTimeout(() => {
      onChange(detail.checked);
    }, 1);
  };
  return (
    <div className={clsx('checkbox-container', value && 'checkbox-active')}>
      <IonCheckbox
        disabled={disabled}
        onIonChange={handleCheckboxChange}
        checked={value}
        labelPlacement="end"
        slot="start"
        color={color}
        {...(checkboxId && { id: checkboxId })}
      >
        {!disableLabelClick && label && label}
      </IonCheckbox>
      {disableLabelClick && label && (
        <label
          className={clsx(
            'checkbox-label-external',
            disabled && 'checkbox-label-external--disabled'
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
